import { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { lpResponsiveStyles, SYDM2_SLUG } from "./constants";
import { useRouter } from "next/router";
import { countPadStringArray } from "../../../../lib/util";

const useStyles = makeStyles((theme) => {
  const header = lpResponsiveStyles(theme, (baseWidth) => ({
    width: baseWidth,
    position: baseWidth === "100vw" ? "fixed" : "absolute",
  }));
  return {
    spHeaderMargin: {
      height: "65px",
    },
    spHeader: {
      top: "0",
      zIndex: 10,
      backgroundColor: "#FFABC8",
      height: "65px",
      "& > .spHeaderContainer": {
        height: "inherit",
        padding: "8px",
        display: "flex",
        justifyContent: "space-between",
        "& > .spHeaderSummaryArea": {
          display: "flex",
          "& > .spHeaderSupportCountArea": {
            marginRight: "10px",
            "& .spHeaderSupportCountLabel": {
              height: "20px",
              marginBottom: "6px",
            },
            "& .spHeaderSupportCountValue": {
              verticalAlign: "bottom",
            },
          },
          "& > .spHeaderSupportAmountArea": {
            "& .spHeaderSupportAmountLabel": {
              height: "20px",
              marginBottom: "6px",
            },
            "& .spHeaderSupportAmountValue": {},
          },
        },
        "& > .spHeaderButtonArea": {
          "& > .spHeaderButton": {
            height: "49px",
            // width: "124px",
            padding: "5px",
            borderRadius: "5px",
            backgroundColor: "#000",
            color: "#FFF",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
            "& > .spHeaderButtonText": {},
            "& > .spHeaderButtonLogo": {
              marginLeft: "2px",
            },
          },
        },
      },
      "& .spHeaderPetalNumber": {
        height: "17px",
        width: "17px",
        color: "#FFF",
        fontSize: "16px",
        padding: "1px",
        display: "inline-block",
        backgroundImage: "url(/img/lp/petal.png)",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
      },
      ...header,
    },
    whenAfford: {
      ["@media (max-width:370px)"]: {
        display: "none",
      },
    },
  };
});

type Props = {
  orderCount: number | undefined | null;
  supportAmount: number | undefined | null;
};
export const SpHeader: FC<Props> = (props: Props) => {
  const router = useRouter();
  const classes = useStyles();
  const orderCount = countPadStringArray(props.orderCount || 0, 4);
  const supportAmount = countPadStringArray(props.supportAmount ?? 0, 8);
  return (
    <>
      <div className={classes.spHeader}>
        <div className="spHeaderContainer">
          <div className="spHeaderSummaryArea">
            <div className="spHeaderSupportCountArea">
              <div className="spHeaderSupportCountLabel">
                <img src="/img/lp/support_count_label.png" height={18} />
              </div>
              <div className="spHeaderSupportCountValue">
                {orderCount.map((num, index) => (
                  <span className="spHeaderPetalNumber" key={index}>
                    {num}
                  </span>
                ))}
                <span style={{ color: "#8C1442", fontSize: "10px" }}>人</span>
              </div>
            </div>
            <div className="spHeaderSupportAmountArea">
              <div className="spHeaderSupportAmountLabel">
                <img src="/img/lp/support_amount_label.png" height={18} />
              </div>
              <div className="spHeaderSupportAmountValue">
                {supportAmount.map((num, index) => (
                  <span className="spHeaderPetalNumber" key={index}>
                    {num}
                  </span>
                ))}
                <span style={{ color: "#8C1442", fontSize: "10px" }}>円</span>
              </div>
            </div>
          </div>
          <div className="spHeaderButtonArea">
            <div
              className="spHeaderButton"
              onClick={() => {
                router.push({ pathname: `/project/${SYDM2_SLUG}` });
              }}
            >
              <div className="spHeaderButtonText" style={{ fontSize: "10px" }}>
                <span>
                  クラファン<span className={classes.whenAfford}>詳細</span>
                </span>
                <br />
                <span>はこちら！</span>
              </div>
              <div className={`spHeaderButtonLogo ${classes.whenAfford}`}>
                <img src="/img/lp/logo-icon.png" width={32} height={32} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*<div className={classes.spHeaderMargin} />*/}
    </>
  );
};
